<div class="container">
  <div class="title">{{ title }}</div>
  <div class="description">
    @if (showDescription) {
      @if (description) {
        {{ description }}
      } @else {
        <ng-container i18n="@@TwoFactorMethodSetupInitDescription">We will send you a verification code to authenticate for future logins.</ng-container>
      }
    }
  </div>
  @if (infoMessage) {
    <ppl-info-box
      type="warning"
      [text]="infoMessage"></ppl-info-box>
  }
  <ng-content></ng-content>
</div>
